(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-usps-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarUsps extends HTMLElement {
    constructor() {
      super();

      // Check if the screen is mobile. True if mobile, false if desktop.
      this.isMobile = () => window.matchMedia('(max-width: 899px)').matches;

      // Update items list, filtering out hidden items on mobile
      this.updateItems();

      if (!this.items.length) return;

      // Set the delay to 5 seconds
      this.delay = 5000;
      this.current = 0;
      this.interval = null;


      this.showCurrent();

      /* Event listener for when the screen is resized */
      window.addEventListener('resize', () => {
        this.updateItems();
        if (this.isMobile()) {
          this.current = 0;
          this.showCurrent();
          this.start();
        } else {
          this.stop();
          this.showAll();
        }
      });

      /* Event listener for when the section is visible */
      const obs = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.start();
          else this.stop();
        });
      });

      obs.observe(this);
    }

    /* Update items list, filtering out hidden items on mobile */
    updateItems() {
      const allItems = this.querySelectorAll('[data-usp-item]');
      if (this.isMobile()) {
        // Filter out items that should be hidden on mobile
        this.items = Array.from(allItems).filter(item => 
          !item.hasAttribute('data-hide-on-mobile')
        );
      } else {
        // On desktop, include all items
        this.items = Array.from(allItems);
      }
    }

    /* Show the current item. If the screen isnt mobile, show all items. If the screen is mobile, show only the active item. */
    showCurrent() {
      if (!this.isMobile()) return this.showAll();

      this.items.forEach((item, i) => {
        item.classList.toggle('is-active', i === this.current);
      });
    }

    /* Show all items. */
    showAll() {
      this.items.forEach((item) => item.classList.add('is-active'));
    }

    /* Start the interval to show the next item every 5 seconds. */
    start() {
      if (!this.isMobile() || this.items.length <= 1 || this.interval) return;

      this.interval = setInterval(() => {
        this.current = (this.current + 1) % this.items.length;
        this.showCurrent();
      }, this.delay);
    }

    /* Stop the interval. */
    stop() {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  window.customElements.define('announcement-bar-usps', AnnouncementBarUsps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  const footerContainer = document.querySelector('[data-footer]');
  const desktopParent = document.querySelector('[data-footer-desktop]');
  const mobileParent = document.querySelector('[data-footer-mobile]');

  function moveBlock() {
    if (window.innerWidth < 900) {
      // Mobile → move inside mobile parent
      if (mobileParent && mobileParent !== footerContainer.parentElement) {
        mobileParent.appendChild(footerContainer);
      }
    } else {
      // Desktop → move inside desktop parent
      if (desktopParent && desktopParent !== footerContainer.parentElement) {
        desktopParent.appendChild(footerContainer);
      }
    }
  }

  moveBlock();
  window.addEventListener('resize', moveBlock);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["last-seen-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    class LastSeenProducts extends HTMLElement {
      constructor() {
        super();
        
        this.products = [];
      }

      connectedCallback() {
        this.hydrateProductList();
      }
      
      hydrateProductList() {
        const productHandle = this.getAttribute('data-current-product-handle');
        if (!productHandle) return;

        // Get existing product handles from sessionStorage
        const storageKey = 'lastSeenProducts';
        let productHandles = [];
        
        try {
          const stored = sessionStorage.getItem(storageKey);
          if (stored) {
            productHandles = JSON.parse(stored);
          }
        } catch (e) {
          // If parsing fails, start with empty array
          productHandles = [];
        }

        // Remove the product handle if it already exists
        productHandles = productHandles.filter(handle => handle !== productHandle);
        
        // Limit storage to 20 products for performance (before adding current)
        // This ensures we have enough displayable products after filtering out current
        const maxStorageSize = 20;
        if (productHandles.length > maxStorageSize) {
          productHandles = productHandles.slice(-maxStorageSize);
        }
        
        // Append current product at the end (most recent) for storage
        productHandles.push(productHandle);
        
        // Save back to sessionStorage (includes current product)
        try {
          sessionStorage.setItem(storageKey, JSON.stringify(productHandles));
        } catch (e) {
          // If storage fails, silently fail
        }
        
        // Filter out the current product handle so we don't show the product we're already viewing
        const currentHandle = this.getAttribute('data-current-product-handle');
        let filteredHandles = productHandles.filter(handle => handle !== currentHandle);
        
        // Limit display to double the grid size (for slider)
        const gridSize = parseInt(this.getAttribute('data-size')) || 4;
        this.products = filteredHandles.slice(-(gridSize * 2));
        
        // If no products after filtering, hide the section immediately
        if (this.products.length === 0) {
          this.hideSection();
          return;
        }
        
        // Fetch and display product cards
        this.fetchProductCards();
      }
      
      hideSection() {
        const sectionElement = this.closest('.section-last-seen-products');
        if (sectionElement) {
          sectionElement.style.display = 'none';
        }
      }
      
      async fetchProductCards() {
        const resultsContainer = this.querySelector('[data-results-container]');
        if (!resultsContainer || this.products.length === 0) return;
        
        // Fetch all product cards in parallel
        const fetchPromises = this.products.map(async (handle) => {
          try {
            const url = `/products/${handle}?view=card`;
            const response = await fetch(url);
            
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            
            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            // Find the product card content - the card template renders a product-block element
            // The view=card template should return just the product-block snippet
            let productCard = doc.querySelector('product-block');
            
            if (productCard) {
              const wrapper = document.createElement('div');
              wrapper.className = 'slider__item';
              wrapper.appendChild(productCard.cloneNode(true));
              return wrapper;
            }
            
            return null;
          } catch (error) {
            console.error(`Error fetching product card for ${handle}:`, error);
            return null;
          }
        });
        
        // Wait for all fetches to complete
        const productCards = await Promise.all(fetchPromises);
        
        // Clear placeholders
        resultsContainer.innerHTML = '';
        
        // Filter out null results and append to container
        const validCards = productCards.reverse().filter(card => card !== null);
        validCards.forEach(card => {
          resultsContainer.appendChild(card);
        });
        
        // If no products to display, hide the entire section
        if (validCards.length === 0) {
          this.hideSection();
          return;
        }
        
        // Refresh the carousel slider if it exists
        const carousel = this.querySelector('carousel-slider');
        if (carousel && typeof carousel.refresh === 'function') {
          carousel.refresh();
        }
      }    
    }

    if (!customElements.get('last-seen-products')) {
      customElements.define('last-seen-products', LastSeenProducts);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'related-products'
    var productRecommendationsSection = document.querySelector(".related-products");
    if (productRecommendationsSection === null) { return; }
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", productRecommendationsSection.dataset.url);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      }
    };
    request.send();
  };
  // fetch when section reloads in editor
  document.addEventListener("shopify:section:load", function(event) {
    if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsCarousel extends HTMLElement {
    constructor() {
      super();
      
      this.splideSettings = {
        waitForTransition: true,
        wheel: true,
        drag: 'free',
        wheelMinThreshold: 1,
        mediaQuery: 'min',
        releaseWheel: true,
        autoWidth: false,
        pagination: false,
        arrows: true,
        gap: 16,
        padding: 16,
        perPage: 1,
        breakpoints: {
          768: {
            gap: 20,
            padding: 0,
            perPage: 2,
          },
          1200: {
            gap: 30,
            perPage: 4,
          },
        }
      }
    }
    
    connectedCallback() {
      var splide = new window.Splide(this, this.splideSettings);
      splide.mount();
    }
  }
  
  customElements.define('reviews-carousel', ReviewsCarousel);

  } catch(e) { console.error(e); }
})();
})();
